import { type PlateHistoryItem, plateHistoryUtils } from '../../utils/plate-history'

interface PlateHistoryProps {
  onPlateSelect: (plate: string) => void
  currentPlate?: string
}

function PlateHistory({ onPlateSelect, currentPlate }: PlateHistoryProps) {
  const history = plateHistoryUtils.getPlateHistory()

  if (history.length === 0) {
    return null
  }

  const handlePlateClick = (plate: string) => {
    onPlateSelect(plate)
  }

  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp)
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
  }

  return (
    <div
      style={{
        marginBottom: '20px',
        padding: '15px',
        backgroundColor: '#e9ecef',
        borderRadius: '8px',
        border: '1px solid #495057',
      }}
    >
      <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#212529', fontWeight: '600' }}>
        Placas utilizadas recentemente:
      </h4>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {history.map((item: PlateHistoryItem) => (
          <button
            key={item.plate}
            type="button"
            onClick={() => handlePlateClick(item.plate)}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 12px',
              backgroundColor: currentPlate === item.plate ? '#cce7ff' : '#ffffff',
              border: currentPlate === item.plate ? '2px solid #0056b3' : '1px solid #6c757d',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontSize: '14px',
              width: '100%',
              textAlign: 'left',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <span style={{ fontWeight: '600', color: '#212529' }}>{item.plate}</span>
              <span style={{ fontSize: '12px', color: '#495057' }}>{formatDate(item.timestamp)}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default PlateHistory
